import * as ambassadorWixTipsSettingsV1TipSettings from './tips-settings-v1-tip-settings-tip-settings.http.js';
import * as ambassadorWixTipsSettingsV1TipSettingsTypes from './tips-settings-v1-tip-settings-tip-settings.types.js';
import * as ambassadorWixTipsSettingsV1TipSettingsUniversalTypes from './tips-settings-v1-tip-settings-tip-settings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function queryTipSettings(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixTipsSettingsV1TipSettingsUniversalTypes.QueryTipSettingsRequest,
  ambassadorWixTipsSettingsV1TipSettingsTypes.QueryTipSettingsRequest,
  ambassadorWixTipsSettingsV1TipSettingsUniversalTypes.QueryTipSettingsResponse,
  ambassadorWixTipsSettingsV1TipSettingsTypes.QueryTipSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixTipsSettingsV1TipSettings.queryTipSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/tip-settings/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateTipSettings(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixTipsSettingsV1TipSettingsUniversalTypes.UpdateTipSettingsRequest,
  ambassadorWixTipsSettingsV1TipSettingsTypes.UpdateTipSettingsRequest,
  ambassadorWixTipsSettingsV1TipSettingsUniversalTypes.UpdateTipSettingsResponse,
  ambassadorWixTipsSettingsV1TipSettingsTypes.UpdateTipSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixTipsSettingsV1TipSettings.updateTipSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/tip-settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createTipSettings(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixTipsSettingsV1TipSettingsUniversalTypes.CreateTipSettingsRequest,
  ambassadorWixTipsSettingsV1TipSettingsTypes.CreateTipSettingsRequest,
  ambassadorWixTipsSettingsV1TipSettingsUniversalTypes.CreateTipSettingsResponse,
  ambassadorWixTipsSettingsV1TipSettingsTypes.CreateTipSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixTipsSettingsV1TipSettings.createTipSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/tip-settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createDefaultTipSettings(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixTipsSettingsV1TipSettingsUniversalTypes.CreateDefaultTipSettingsRequest,
  ambassadorWixTipsSettingsV1TipSettingsTypes.CreateDefaultTipSettingsRequest,
  ambassadorWixTipsSettingsV1TipSettingsUniversalTypes.CreateDefaultTipSettingsResponse,
  ambassadorWixTipsSettingsV1TipSettingsTypes.CreateDefaultTipSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixTipsSettingsV1TipSettings.createDefaultTipSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/tip-settings/create-default',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteTipSettings(): __PublicMethodMetaInfo<
  'DELETE',
  { tipSettingsId: string },
  ambassadorWixTipsSettingsV1TipSettingsUniversalTypes.DeleteTipSettingsRequest,
  ambassadorWixTipsSettingsV1TipSettingsTypes.DeleteTipSettingsRequest,
  ambassadorWixTipsSettingsV1TipSettingsUniversalTypes.DeleteTipSettingsResponse,
  ambassadorWixTipsSettingsV1TipSettingsTypes.DeleteTipSettingsResponse
> {
  const payload = { tipSettingsId: ':tipSettingsId' } as any;

  const getRequestOptions =
    ambassadorWixTipsSettingsV1TipSettings.deleteTipSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/tip-settings/{tipSettingsId}',
    pathParams: { tipSettingsId: 'tipSettingsId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  TipSettings as TipSettingsOriginal,
  TipSettingsIdentifierOneOf as TipSettingsIdentifierOneOfOriginal,
  TipType as TipTypeOriginal,
  TipTypeWithLiterals as TipTypeWithLiteralsOriginal,
  Preset as PresetOriginal,
  StaffDistributionMethod as StaffDistributionMethodOriginal,
  StaffDistributionMethodWithLiterals as StaffDistributionMethodWithLiteralsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  QueryTipSettingsRequest as QueryTipSettingsRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryTipSettingsResponse as QueryTipSettingsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  UpdateTipSettingsRequest as UpdateTipSettingsRequestOriginal,
  UpdateTipSettingsResponse as UpdateTipSettingsResponseOriginal,
  CreateTipSettingsRequest as CreateTipSettingsRequestOriginal,
  CreateTipSettingsResponse as CreateTipSettingsResponseOriginal,
  CreateDefaultTipSettingsRequest as CreateDefaultTipSettingsRequestOriginal,
  CreateDefaultTipSettingsResponse as CreateDefaultTipSettingsResponseOriginal,
  DeleteTipSettingsRequest as DeleteTipSettingsRequestOriginal,
  DeleteTipSettingsResponse as DeleteTipSettingsResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  UpdateTipSettingsApplicationErrors as UpdateTipSettingsApplicationErrorsOriginal,
  CreateTipSettingsApplicationErrors as CreateTipSettingsApplicationErrorsOriginal,
  CreateDefaultTipSettingsApplicationErrors as CreateDefaultTipSettingsApplicationErrorsOriginal,
  DeleteTipSettingsApplicationErrors as DeleteTipSettingsApplicationErrorsOriginal,
} from './tips-settings-v1-tip-settings-tip-settings.types.js';
